module.exports = __webpack_public_path__ + "img/logo-meoempresas-vertical.d9e12184.png";